import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSave } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import config from '../config';  // Assuming config is in the same folder

const EditStockModal = ({ barrelId, yard, date, onClose, fetchBarrelStock }) => {
    const [updatedYard, setUpdatedYard] = useState(yard);
    const [updatedDate, setUpdatedDate] = useState(date);

    const handleSave = async () => {
        // Prepare updated data
        const updatedData = { yard: updatedYard, date: updatedDate };

        try {
            // Use axios for the PUT request
            const response = await axios.put(`${config.apiUrl}/stock/updatebarrel/${barrelId}`, updatedData, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            // Close modal and refresh stock data on success
            onClose();
            fetchBarrelStock();
        } catch (error) {
            console.error('Error updating barrel:', error);
        }
    };

    return (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
            <div className="bg-gray-800 p-6 rounded-2xl shadow-md max-w-xs w-full relative">
                <button onClick={() => onClose(null)} className="absolute top-2 right-2">
                    <FontAwesomeIcon className="text-red-500" icon={faTimes} />
                </button>
                <h3 className="text-lg font-semibold mb-4 text-center text-white">Edit Stock</h3>
                <div className="space-y-4">
                    <div>
                        <label className="text-white">Yard:</label>
                        <input
                            type="text"
                            value={updatedYard}
                            onChange={(e) => setUpdatedYard(e.target.value)}
                            className="w-full p-2 border border-gray-600 rounded text-gray-500"
                        />
                    </div>
                    <div>
                        <label className="text-white">Date:</label>
                        <input
                            type="date"
                            value={updatedDate}
                            onChange={(e) => setUpdatedDate(e.target.value)}
                            className="w-full p-2 border border-gray-600 rounded text-gray-500"
                        />
                    </div>
                    <button
                        onClick={handleSave}
                        className="bg-blue-600 text-white px-4 py-2 rounded-lg w-full hover:bg-blue-700 transition-colors"
                    >
                        <FontAwesomeIcon icon={faSave} /> Save
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EditStockModal;
